import {
    RAW_MESSAGE_VIEW_OPEN_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    details: null,
    title: null,
    isHtml: false, 
    html: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case RAW_MESSAGE_VIEW_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, details: action.payload.data, title: action.payload.title, isHtml: action.payload.isHtml, html: action.payload.html}

        case CLEAR_REDUX:
            return ["", "RAW_MESSAGE_VIEW"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};